import { render, staticRenderFns } from "./user-left-room.html?vue&type=template&id=5123bf98&scoped=true&"
import script from "./user-left-room.js?vue&type=script&lang=js&"
export * from "./user-left-room.js?vue&type=script&lang=js&"
import style0 from "./user-left-room.scss?vue&type=style&index=0&id=5123bf98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123bf98",
  null
  
)

export default component.exports